import gameAxiosInstance from '../api/gameAxios';

export const checkScore = async ({
  externalId,
  externalContent,
  externalContentOrigin,
  externalCourseId,
}: {
  externalId: string;
  externalContent?: string;
  externalContentOrigin?: 'course' | 'plano-adaptativo' | 'navegation';
  externalCourseId?: string;
}) => {
  try {
    const { data } = await gameAxiosInstance.post(
      `v1/points/check-points/${externalId}`,
      {
        externalContent,
        externalContentOrigin,
        externalCourseId,
      }
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
